import ProfileImage from "common/components/ui/ProfileImage";
import Skeleton from "common/components/ui/Skeleton";

import type { JSX } from "react";

type ProfileHeadingProps = { extraComponent?: JSX.Element } & (
  | {
      fullName: string;
      occupation: string;
      pictureUrl: string;
      isLoading?: false;
    }
  | { isLoading: true }
);

export default function ProfileHeading(props: ProfileHeadingProps) {
  const { extraComponent } = props;

  return (
    <div className="flex grow gap-x-1.5 items-center">
      {props.isLoading === true ? (
        <Skeleton className="rounded-full size-8" />
      ) : (
        <ProfileImage src={props.pictureUrl} size="sm" />
      )}
      <div className="flex flex-col gap-y-0.5 grow">
        {props.isLoading === true ? (
          <>
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-4 w-28" />
          </>
        ) : (
          <>
            <span
              className="text-xs-bold text-left line-clamp-1"
              title={props.fullName}
            >
              {props.fullName}
            </span>
            <span
              className="text-button-xxs text-black-500 line-clamp-1 text-left"
              title={props.occupation}
            >
              {props.occupation}
            </span>
          </>
        )}
      </div>
      {extraComponent}
    </div>
  );
}
